import { theme } from '../../theme';
// TODO: Tokenize RGBA values (waiting on new spec from Design Team)
export const colorMap = {
    primary: {
        solid: {
            backgroundColor: theme.colors.BB100,
            color: theme.colors.LM_NU0,
            ':hover': { backgroundColor: theme.colors.BB110 },
            ':focus': {
                backgroundColor: theme.colors.BB120,
                outline: `2px solid ${theme.colors.BB80}`,
            },
            ':active': { backgroundColor: theme.colors.BB120 },
        },
        light: {
            backgroundColor: 'rgba(30, 108, 248, 0.1)',
            color: theme.colors.BB100,
            ':hover': { backgroundColor: 'rgba(30, 108, 248, 0.15)' },
            ':focus': {
                backgroundColor: 'rgba(30, 108, 248, 0.2)',
                outline: `2px solid ${theme.colors.BB80}`,
            },
            ':active': { backgroundColor: 'rgba(30, 108, 248, 0.2)' },
        },
        clear: {
            backgroundColor: 'transparent',
            color: theme.colors.BB100,
            ':hover': { backgroundColor: 'rgba(30, 108, 248, 0.05)' },
            ':focus': {
                backgroundColor: 'rgba(30, 108, 248, 0.1)',
                outline: `2px solid ${theme.colors.BB80}`,
            },
            ':active': {
                backgroundColor: 'rgba(30, 108, 248, 0.1)',
            },
        },
    },
    secondary: {
        solid: {
            backgroundColor: theme.colors.LM_NU80,
            color: theme.colors.LM_NU0,
            ':hover': { backgroundColor: theme.colors.LM_NU90 },
            ':focus': {
                backgroundColor: theme.colors.LM_NU100,
                outline: `2px solid ${theme.colors.BB80}`,
            },
            ':active': {
                backgroundColor: theme.colors.LM_NU100,
            },
        },
        light: {
            backgroundColor: 'rgba(41, 55, 73,0.05)',
            color: theme.colors.LM_NU80,
            ':hover': { backgroundColor: 'rgba(41, 55, 73, 0.1)' },
            ':focus': {
                backgroundColor: 'rgba(41, 55, 73, 0.15)',
                outline: `2px solid ${theme.colors.BB80}`,
            },
            ':active': {
                backgroundColor: 'rgba(41, 55, 73, 0.15)',
            },
        },
        clear: {
            backgroundColor: 'transparent',
            color: theme.colors.LM_NU80,
            ':hover': { backgroundColor: 'rgba(41, 55, 73, 0.05)' },
            ':focus': {
                backgroundColor: 'rgba(41, 55, 73, 0.1)',
                outline: `2px solid ${theme.colors.BB80}`,
            },
            ':active': {
                backgroundColor: 'rgba(41, 55, 73, 0.1)',
            },
        },
    },
    white: {
        solid: {
            backgroundColor: theme.colors.LM_NU0,
            color: theme.colors.BB100,
            ':hover': { backgroundColor: theme.colors.LM_NU10 },
            ':focus': {
                backgroundColor: theme.colors.LM_NU20,
                outline: `2px solid ${theme.colors.BB80}`,
            },
            ':active': {
                backgroundColor: theme.colors.LM_NU20,
            },
        },
        light: {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            color: theme.colors.BB100,
            ':hover': { backgroundColor: 'rgba(255, 255, 255, 0.15)' },
            ':focus': {
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                outline: `2px solid ${theme.colors.BB80}`,
            },
            ':active': {
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
            },
        },
        clear: {
            backgroundColor: 'transparent',
            color: theme.colors.BB100,
            ':hover': { backgroundColor: 'rgba(255, 255, 255, 0.05)' },
            ':focus': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                outline: `2px solid ${theme.colors.BB80}`,
            },
            ':active': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
        },
    },
    positive: {
        solid: {
            backgroundColor: theme.colors.PO100,
            color: theme.colors.LM_NU0,
            ':hover': {
                backgroundColor: theme.colors.PO110,
            },
            ':focus': {
                backgroundColor: theme.colors.PO120,
                outline: `2px solid ${theme.colors.PO80}`,
            },
            ':active': {
                backgroundColor: theme.colors.PO120,
            },
        },
        light: {
            backgroundColor: theme.colors.GR20T,
            color: theme.colors.GR100,
            ':hover': { backgroundColor: theme.colors.GR30T },
            ':focus': {
                backgroundColor: theme.colors.GR40T,
                outline: `2px solid ${theme.colors.GR80}`,
            },
            ':active': {
                backgroundColor: theme.colors.GR40T,
            },
        },
        clear: {
            backgroundColor: 'transparent',
            color: theme.colors.PO100,
            ':hover': { backgroundColor: 'rgba(6, 134, 102, 0.1)' },
            ':focus': {
                backgroundColor: 'rgba(6, 134, 102, 0.15)',
                outline: `2px solid ${theme.colors.PO80}`,
            },
            ':active': {
                backgroundColor: 'rgba(6, 134, 102, 0.15)',
            },
        },
    },
    negative: {
        solid: {
            backgroundColor: theme.colors.NE100,
            color: theme.colors.LM_NU0,
            ':hover': {
                backgroundColor: theme.colors.NE110,
            },
            ':focus': {
                backgroundColor: theme.colors.NE120,
                outline: `2px solid ${theme.colors.NE80}`,
            },
            ':active': {
                backgroundColor: theme.colors.NE120,
            },
        },
        light: {
            backgroundColor: 'rgba(197, 58, 58, 0.1)',
            color: theme.colors.NE100,
            ':hover': { backgroundColor: 'rgba(197, 58, 58, 0.15)' },
            ':focus': {
                backgroundColor: 'rgba(197, 58, 58, 0.2)',
                outline: `2px solid ${theme.colors.NE80}`,
            },
            ':active': {
                backgroundColor: 'rgba(197, 58, 58, 0.2)',
            },
        },
        clear: {
            backgroundColor: 'transparent',
            color: theme.colors.NE100,
            ':hover': { backgroundColor: 'rgba(197, 58, 58, 0.1)' },
            ':focus': {
                backgroundColor: 'rgba(197, 58, 58, 0.15)',
                outline: `2px solid ${theme.colors.NE80}`,
            },
            ':active': {
                backgroundColor: 'rgba(197, 58, 58, 0.15)',
            },
        },
    },
    warning: {
        solid: {
            backgroundColor: theme.colors.WA100,
            color: theme.colors.LM_NU100,
            ':hover': {
                backgroundColor: theme.colors.WA110,
            },
            ':focus': {
                backgroundColor: theme.colors.WA120,
                outline: `2px solid ${theme.colors.WA80}`,
            },
            ':active': {
                backgroundColor: theme.colors.WA120,
            },
        },
        light: {
            backgroundColor: 'rgba(246, 171, 46, 0.1)',
            color: theme.colors.WA100,
            ':hover': { backgroundColor: 'rgba(246, 171, 46, 0.15)' },
            ':focus': {
                backgroundColor: 'rgba(246, 171, 46, 0.2)',
                outline: `2px solid ${theme.colors.WA80}`,
            },
            ':active': {
                backgroundColor: 'rgba(246, 171, 46, 0.2)',
            },
        },
        clear: {
            backgroundColor: 'transparent',
            color: theme.colors.WA100,
            ':hover': { backgroundColor: 'rgba(246, 171, 46, 0.1)' },
            ':focus': {
                backgroundColor: 'rgba(246, 171, 46, 0.15)',
                outline: `2px solid ${theme.colors.WA80}`,
            },
            ':active': {
                backgroundColor: 'rgba(246, 171, 46, 0.15)',
            },
        },
    },
};
const paddingMap = {
    small: { padding: '0.375rem .5rem' },
    regular: {
        padding: '0.625rem .75rem',
    },
    large: { padding: '0.875rem 1rem' },
};
export const paddingSelect = (size) => paddingMap[size];
export const colorSelect = (variant, fill) => colorMap[variant][fill];
export const getStyles = (variant, fill, size) => (Object.assign(Object.assign({}, colorSelect(variant, fill)), paddingSelect(size)));
//# sourceMappingURL=styles.js.map